import { apiClient } from "../services/apiClient";
import { ATP_API_URL } from "../config/apiConfig";

const isValidPath = (p) => p && p !== "string" && p !== "";

const toDocEntry = (key, label, path) => ({
  key,
  documentName: label,
  files: [
    {
      isUploaded: true,
      fileName: path.split("\\").pop() || label,
      filePath: path,
    },
  ],
});

/**
 * Builds a normalised documents array from all *Path fields on the record.
 */
const buildDocuments = (r) => {
  const pathMap = [
    { key: "doc_aadhar", label: "Aadhar Card", path: r.aadharCardPath },
    { key: "doc_pan", label: "PAN Card", path: r.panCardPath },
    {
      key: "doc_partnershipDeed",
      label: "Partnership Deed",
      path: r.partnershipDeedPath,
    },
    {
      key: "doc_llpCertificate",
      label: "LLP Certificate",
      path: r.uploadLLPCertificatePath || r.llpCertificatePath,
    },
    {
      key: "doc_aadharBoth",
      label: "Aadhar of Both Partners",
      path: r.aadharOfBothPartnersPath,
    },
    {
      key: "doc_coi",
      label: "Certificate of Incorporation",
      path: r.certificateOfIncorporationPath,
    },
    { key: "doc_directorPan", label: "Director PAN", path: r.directorPANPath },
    {
      key: "doc_directorAadhar",
      label: "Director Aadhar",
      path: r.directorAadharPath,
    },
    {
      key: "doc_msme_certificate",
      label: "MSME Certificate",
      path: r.msmeCertificatePath,
    },
    {
      key: "doc_utility_bill",
      label: "Utility Bill",
      path: r.utilityBillDocumentPath,
    },
    {
      key: "doc_bank_proof",
      label: "Passbook / Cancelled Cheque",
      path: r.passbookOrCancelledChequePath,
    },
    {
      key: "third_party_file",
      label: "Signed Form (Third Party)",
      path: r.uploadSignedFormPath,
    },
  ];

  const documents = pathMap
    .filter((d) => isValidPath(d.path))
    .map((d) => toDocEntry(d.key, d.label, d.path));

  (r.gstList || []).forEach((g, i) => {
    const certPath = isValidPath(g.gstCertificatePath)
      ? g.gstCertificatePath
      : null;
    documents.push({
      key: `gst_file_${i}`,
      documentName: `GST Certificate — ${g.gstNumber || i + 1}`,
      files: certPath
        ? [
            {
              isUploaded: true,
              fileName: certPath.split("\\").pop() || "GST",
              filePath: certPath,
            },
          ]
        : [],
    });
  });

  return documents;
};

/**
 * Fetches existing KYC/entity data by onboardingId (entityPrimaryId).
 *
 * @param {number} id - entityPrimaryId / onboardingId from URL
 * @returns {{ success: boolean, data: object|null, documents: Array, error?: string }}
 */
export const fetchKYCDetailsByIdAction = async (id) => {
  try {
    const body = {
      id,
      category: null,
      entityName: null,
      email: null,
      documentStatus: false,
      isVerified: false,
      pageNumber: 1,
      pageSize: 10,
    };

    const response = await apiClient.post(
      ATP_API_URL.GET_ALL_DATA_SEARCH,
      body,
    );

    if (response?.status === 200 && response.data) {
      const raw = response.data;
      const record = Array.isArray(raw)
        ? raw[0]
        : Array.isArray(raw?.data)
          ? raw.data[0]
          : raw?.data || null;

      if (!record) return { success: false, data: null, documents: [] };

      return { success: true, data: record, documents: buildDocuments(record) };
    }

    return { success: false, data: null, documents: [] };
  } catch (error) {
    return { success: false, data: null, documents: [], error: error.message };
  }
};
